import Text from "@/components/common/Typography/Text";
import { Col, Row } from "antd";
import Image from "next/image";

import Title from "antd/es/typography/Title";
import { useTranslation } from "react-i18next";
import { useIsDesktop } from "@/hooks/app/useIsDesktop";
import Link from "@/components/common/Typography/Link";
import NextLink from 'next/link'
import ZaloFillIcon from "@/components/icons/ZaloFillIcon";
import FacebookFillIcon from "@/components/icons/FacebookFillIcon";
import PwaInstallFooterLink from "@/components/common/PwaInstallFooterLink";

const BasicLayoutFooterV1 = () => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation()


  const contact = (
    <>
      <Row key="footer-phone" style={{ marginBottom: '0.5rem' }}>
        <Text className="layout__footer--email"><Text strong>{t("home.call_center")}</Text>: {process.env.NEXT_PUBLIC_COMPANY_PHONE || ""}</Text>
      </Row>
      <Row key="footer-email" style={{ marginBottom: '0.5rem' }}>
        <Text className="layout__footer--email">
          <Text strong>Email</Text>: {process.env.NEXT_PUBLIC_COMPANY_EMAIL}
        </Text>
      </Row>
      <Row key="footer-office" style={{ marginBottom: '0.5rem' }}>
        <Text className="layout__footer--address">
          <Text strong>{t("home.office")}</Text>: <Link href="https://maps.app.goo.gl/WzT2FxUCqzu9aMES6" target='_blank'><Text>{process.env.NEXT_PUBLIC_COMPANY_ADDRESS || ""}</Text></Link>
        </Text>
      </Row>
      <Row key="footer-hc-office" style={{ marginBottom: '0.5rem' }}>
        <Text className="layout__footer--address">
          <Text strong>{t("home.hc_office")}</Text>: <Link href="https://maps.app.goo.gl/5qBtKsDzY3wJ1cy36" target='_blank'>
            <Text>
              290D/8 Dương Bá Trạc, P. Chánh Hưng, TP. Hồ Chí Minh
            </Text>
          </Link>
        </Text>
      </Row>
    </>
  );

  const logos = (
    <Row gutter={[24, 0]} align="middle">
      <Col>
        <a
          href="http://online.gov.vn/Website/chi-tiet-130882"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            width={120}
            height={48}
            alt="Bộ Công Thương"
            title="Bộ Công Thương"
            src="/static/logo_bct.png"
            objectFit="contain"
          />
        </a>
      </Col>
      <Col>
        <a
          href="//www.dmca.com/Protection/Status.aspx?ID=071c098c-df33-4fd1-83f2-4ad3407cebb5"
          title="DMCA.com Protection Status"
          className="dmca-badge"
        >
          <img
            className="payment-icon"
            src="/static/dmca.jpg"
            alt="DMCA Protection"
          />
        </a>
      </Col>
      <Col>
        <img
          className="payment-icon"
          src="/static/wildcard.jpg"
          alt="Wildcard SSL"
        />
      </Col>
    </Row>
  );

  const payments = (
    <>
      <Row gutter={[24, 0]} align="middle">
        {[
          '/static/images/payments/icons8-visa-240.png',
          '/static/images/payments/mastercard.png',
          '/static/images/payments/jcb.png'
        ].map((url) => {
          const splitedURL = url.split('/')
          const name = splitedURL[splitedURL.length - 1]
          return (
            <Col key={`payment-row1-${name}`} span={8}>
              <img style={{ width: '100%' }} className="payment-icon" src={url} alt={name} />
            </Col>
          )
        })}
      </Row>
      <Row gutter={[24, 0]} align="middle">
        {[
          '/static/momo.png',
          '/static/onepay.png',
        ].map((url) => {
          const splitedURL = url.split('/')
          const name = splitedURL[splitedURL.length - 1]
          return (
            <Col key={`payment-row2-${name}`} span={12}>
              <img style={{ width: '100%' }} className="payment-icon" src={url} alt={name} />
            </Col>
          )
        })}
      </Row>
      <Row gutter={[24, 0]} align="middle">
        {[
          '/static/apple-pay.png',
          '/static/images/ss_pay.jpg',
          '/static/images/payments/qr.png',
        ].map((url) => {
          const splitedURL = url.split('/')
          const name = splitedURL[splitedURL.length - 1]
          return (
            <Col key={`payment-row3-${name}`} span={8}>
              <img style={{ width: '100%' }} className="payment-icon" src={url} alt={name} />
            </Col>
          )
        })}
      </Row>
    </>
  );

  return (
    <>
      <Row justify='center'>
        <Col span={24} className="layout__footer-content">
          <Row className="layout__footer-container" gutter={[30, 15]}>
            <Col xs={24} md={12} sm={24} xl={8}>
              <Row gutter={[30, 20]}>
                <Col xs={24} sm={14} md={24} lg={14} xl={24}>
                  <Row>
                    <Image
                      src={"/static/travel-easy-logo-1x.png"}
                      alt="Travel easy logo on footer"
                      width={240}
                      height={48}
                      quality={100}
                      style={{ marginBottom: '1rem', maxWidth: '100%' }}
                    />
                  </Row>
                  <Row>
                    <Col span={24}>{contact}</Col>
                  </Row>
                  <Row>
                    <Col span={24}>{logos}</Col>
                  </Row>
                </Col>
                <Col xs={24} sm={10} md={24} lg={10} xl={24}>
                  <Row>
                    <Col span={24}>
                      <Text strong style={{ fontSize: 16, fontWeight: 600}}>{t("home.card_payment_support")}</Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col>{payments}</Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xs={24} md={12} xl={16}>
              <Row gutter={[30, 15]}>
                <Col xs={24} sm={12} md={10} lg={12} xl={8}>
                  <Row gutter={[30, 30]}>
                    <Col xs={10} sm={24} xl={24}>
                      <Row>
                        <Text strong style={{ fontSize: 16, fontWeight: 600 }}>
                          {t("app.about_us", { platform: process.env.NEXT_PUBLIC_PLATFORM_NAME })}
                        </Text>
                      </Row>
                      <Row style={{ marginBottom: "0.5rem" }}>
                        <NextLink href={"/gioi-thieu"} target='_blank'>
                          <Text style={{ cursor: 'pointer' }}>{t("common.introduction")}</Text>
                        </NextLink>
                      </Row>

                      <Row style={{ marginBottom: "0.5rem" }}>
                        <NextLink href={"/lien-he"} target='_blank'>
                          <Text style={{ cursor: 'pointer' }}>{t("common.contact")}</Text>
                        </NextLink>
                      </Row>
                      <Row style={{ marginBottom: "0.5rem" }}>
                        <NextLink href={"/#"} target='_blank'>
                          <Text style={{ cursor: 'pointer' }}>{t("common.help")}</Text>
                        </NextLink>
                      </Row>
                      {!isDesktop && (
                        <Row style={{ marginBottom: "0.5rem" }}>
                          <PwaInstallFooterLink />
                        </Row>
                      )}
                    </Col>
                    <Col xs={14} sm={24} xl={24}>
                      <Row>
                        <Text strong style={{ fontSize: 16, fontWeight: 600 }}>
                          {t("app.follow_us_with")}
                        </Text>
                      </Row>
                      {[
                        // {
                        //   icon: "/static/images/social_media/web.png",
                        //   url: "https://www.traveleasy.vn",
                        //   alt: "Website"
                        // },
                        // {
                        //   icon: "/static/images/social_media/Fb.png",
                        //   url: "https://www.facebook.com/TravelEasy.Dulichthatde",
                        //   alt: "Fanpage"
                        // },
                        {
                          icon: "/static/images/social_media/Fb.png",
                          url: "https://www.facebook.com/TravelEasy.Dulichthatde",
                          alt: "Facebook"
                        },
                        {
                          icon: "/static/images/social_media/tiktok.png",
                          url: "https://www.tiktok.com/@traveleasy.vn",
                          alt: "Tiktok"
                        },
                        {
                          icon: "/static/images/social_media/youtube.png",
                          url: "https://www.youtube.com/@traveleasyvn",
                          alt: "Youtube"
                        }
                      ].map(({ icon, url, alt }) => {
                        return (
                          <Row key={`social-${alt}`} style={{marginTop: '0.5rem' }}>
                            <a
                              href={url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Row align='middle' wrap={false} gutter={10}>
                                <Col>
                                  <Image
                                    alt={alt}
                                    src={icon}
                                    height={100}
                                    width={100}
                                    style={{
                                      height: "3.5rem",
                                      width: "3.5rem"
                                    }}
                                  />
                                </Col>
                                <Col>
                                  <Text>{alt}</Text>
                                </Col>
                              </Row>
                            </a>
                          </Row>
                        )
                      })}
                      <Row>
                        <a
                          href="https://zalo.me/1077575192741117044"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Row align='middle' wrap={false} gutter={10}>
                            <Col>
                              <ZaloFillIcon style={{ fontSize: '4.2rem' }} />
                            </Col>
                            <Col>
                              <Text>Zalo</Text>
                            </Col>
                          </Row>
                        </a>
                      </Row>

                    </Col>
                  </Row>

                </Col>
                <Col xs={24} sm={12} md={14} lg={12} xl={16}>
                  <Row gutter={[30, 15]}>
                    <Col xs={10} sm={24} xl={8}>
                      <Row>
                        <Text strong style={{ fontSize: 16, fontWeight: 600}}>
                          {t("app.product")}
                        </Text>
                      </Row>
                      <Row style={{ marginBottom: "0.5rem" }}>
                        <NextLink target='_blank' onClick={() => window.scrollTo(0, 0)} href={"/ve-may-bay"}>
                          <Text style={{ cursor: 'pointer' }}>{t("common.flight")}</Text>
                        </NextLink>
                      </Row>
                      <Row style={{ marginBottom: "0.5rem" }}>
                        <NextLink target='_blank' onClick={() => window.scrollTo(0, 0)} href={"/hotels"}>
                          <Text style={{ cursor: 'pointer' }}>{t("common.hotel")}</Text>
                        </NextLink>
                      </Row>
                      <Row style={{ marginBottom: "0.5rem" }}>
                        <NextLink target='_blank' onClick={() => window.scrollTo(0, 0)} href={"/tours"}>
                          <Text style={{ cursor: 'pointer' }}>Tour</Text>
                        </NextLink>
                      </Row>
                      <Row style={{ marginBottom: "0.5rem" }}>
                        <NextLink target='_blank' onClick={() => window.scrollTo(0, 0)} href={"/esim-du-lich"}>
                          <Text style={{ cursor: 'pointer' }}>eSIM</Text>
                        </NextLink>
                      </Row>
                    </Col>
                    <Col xs={14} sm={24} xl={14}>
                      <Row>
                        <Text strong style={{ fontSize: 16, fontWeight: 600}}>
                          {t("app.policies_regulations")}
                        </Text>
                      </Row>
                      {[
                        { label: t("home.shopping_guide_inspection"), url: "/purchase-guide" },
                        { label: t("home.goods_inspection_policy"), url: "/inspection-policy" },
                        { label: t("home.shipping_policy"), url: "/delivery-policy" },
                        { label: t("common.payment_method"), url: "/phuong-thuc-thanh-toan" },
                        { label: t("home.privacy_policy"), url: "/chinh-sach-bao-mat" },
                        {
                          label: t("home.cancellation_exchange_refund_policy"),
                          url: "/chinh-sach-hoan-huy-doi-tra",
                        },
                        {
                          label: t("home.reception_and_complaint_process"),
                          url: "/complaint-process",
                        }
                      ].map(({ label, url }) => {
                        return (
                          <Row key={url} style={{ marginBottom: "0.5rem" }}>
                            <NextLink target='_blank' href={url}>
                              <Text style={{ cursor: 'pointer' }}>{label}</Text>
                            </NextLink>
                          </Row>
                        )
                      })}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row justify="center" align="middle" className="layout__footer-copyright">
        <Col xs={24}>
          <Text
            className="layout__footer-copyright-text"
            style={{
              display: "block",
              fontSize: "14px",
              lineHeight: "1.5",
              textAlign: "center",
              padding: "0 15px",
            }}
          >
            {t("copyright")}
          </Text>
        </Col>
      </Row>
    </>
  );
};

export default BasicLayoutFooterV1;
